import { grommet } from "grommet";
import { deepMerge } from "grommet/utils";

export const Theme = deepMerge(grommet, {
    global: {
        size: {
            medium: "330px",
        },
        colors: {
            control: "rgba(29, 142, 66, 1)",
            brand: { dark: "rgba(34, 34, 34, 1)", light: "rgba(246, 232, 214, 1)" },
            text: { dark: "rgba(246, 232, 214, 1)", light: "rgba(34, 34, 34, 1)" },
            charcoal: { dark: "rgba(34, 34, 34, 1)", light: "rgba(246, 232, 214, 1)" },
            charcoal_constant: "rgba(34, 34, 34, 1)",
            orange: "rgba(255, 102, 49, 1)",
            cream: { dark: "rgba(246, 232, 214, 1)", light: "rgba(34, 34, 34, 1)" },
            cream_constant: "rgba(246, 232, 214, 1)",
            green_background: { dark: "rgba(29, 142, 66, 1)", light: "rgb(191, 200, 155)" },
            green_foreground: { dark: "rgb(191, 200, 155)", light: "rgba(29, 142, 66, 1)" },
            green_constant: "rgba(29, 142, 66, 1)",
            light_green_constant: "rgb(191, 200, 155)",
        },
        font: {
            family: "Quicksand",
            size: "18px",
        },
        hover: {
            background: {
                color: "green_background",
            },
            color: "charcoal"
        },
        control: {
            border: {
                radius: "30px",
                width: "2px",
                color: "orange"
            },

        },
        focus: {
            border: {
                color: "orange",
            },
            outline: {
                color: "orange",
                size: "2px",
            }
        }
    },
    heading: {
        font: {
            family: "Bogam",
            size: "300px",
            weight: "normal",
        },
        color: "green_constant"
    },
    paragraph: {
        font: {
            family: "Quicksand",
            size: "18px",
        },
        medium: {
            maxWidth: "100%",
        },
    },
    button: {
        default: {
            color: "cream_constant",
            background: {
                color: "orange",
            }
        },
        color: "charcoal",

    },
    menu: {
        background: {
            color: "charcoal"
        },
    },
    card: {
        header: {
            color: "charcoal"
        },
    },
    formField: {
        label: {
            color: "green_constant",
        },
      border: {error: {color: "orange"}, position: "unset"},
    },
    anchor: {
        textDecoration: "underline",

    }
});
